import { render, staticRenderFns } from "./FieldRadio.vue?vue&type=template&id=8890a63a&scoped=true&"
import script from "./FieldRadio.vue?vue&type=script&lang=js&"
export * from "./FieldRadio.vue?vue&type=script&lang=js&"
import style0 from "./FieldRadio.vue?vue&type=style&index=0&id=8890a63a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8890a63a",
  null
  
)

export default component.exports